module.exports = __webpack_public_path__ + "assets/img/driver-btn-3c8162d6.png";